import { TransactionType } from './types'

export const TRANSACTION_TYPES: readonly TransactionType[] = ['buy', 'rent']

export const TRANSACTION_TYPE_LABELS: Record<TransactionType, string> = {
  buy: 'Chat.Filters.TransactionTypes.Buy',
  rent: 'Chat.Filters.TransactionTypes.Rent',
}

export const TRANSACTION_TYPE_QUERY: Record<TransactionType, string> = {
  buy: 'Sell',
  rent: 'Rent',
}
